import React from 'react'
import PropTypes from 'prop-types'
import { LoaderButton, Flex, Box, Copy, Icon } from '@elparking/components'
import { FormattedMessage } from 'react-intl'
import TwoFaModal from '../TwoFaModal'
import {
  FieldGroup,
  EmailField,
  PasswordField,
  LocalForm,
} from '@elparking/form'
import RememberMeField from './RememberMeField'

const LoginForm = ({
  error,
  loading,
  renderReCaptcha,
  refreshReCaptcha,
  disabled,
  socialButtons,
  requestPasswordPath,
  onSubmit,
  logo,
  request,
  start2faAuth,
  onLoginSuccess,
  onReceiveError,
  params,
}) => {
  return (
    <LocalForm
      model="login"
      onSubmit={onSubmit}
      initialState={{
        email: '',
        password: '',
        rememberMe: false,
      }}
    >
      <Box position="relative">
        <Flex flexWrap="wrap">
          <Flex w="100%" p="10px 0 5px 0" justifyContent="center" mb="35px">
            {logo}
          </Flex>
          <Box mb="16px">
            <Copy padding="0" size="medium" fontWeight="book">
              <FormattedMessage defaultMessage="Inicia sesión para continuar" />
            </Copy>
          </Box>
          {error && (
            <Box mb="8px" width="100%">
              <Copy padding="0" color="red" size="small" fontWeight="regular">
                {error.message}
              </Copy>
            </Box>
          )}
          <FieldGroup disabled={loading}>
            <Box w="100%" flex="1 0 100%" mb="8px">
              <EmailField
                disable={loading || disabled}
                dataTest="login-email-field"
                leftIcon={<Icon color="gray" type="user" />}
              />
            </Box>
            <Box w="100%" flex="1 0 100%" mb="8px">
              <PasswordField
                disable={loading || disabled}
                dataTest="login-password-field"
                leftIcon={<Icon color="gray" type="password" />}
              />
            </Box>
            <Box w="100%" flex="1 0 100%" my="24px">
              <RememberMeField
                id="remember-me"
                dataTest="login-remember-me-field"
                label={
                  <Copy padding="0" size="xSmall" fontWeight="regular">
                    <FormattedMessage defaultMessage="Recordarme en este equipo" />
                  </Copy>
                }
              />
            </Box>
          </FieldGroup>
          <LoaderButton
            dataTest="login-submit-button"
            formNoValidate
            loading={loading}
            model="login"
            width="100%"
          >
            <FormattedMessage defaultMessage="Inicia sesión" />
          </LoaderButton>
          <Box w="100%">
            <Copy padding="8px 0 24px 0" align="center">
              <Copy
                as="a"
                href={requestPasswordPath}
                className="js-link-forgot-password"
                color="main"
                size="xSmall"
                fontWeight="book"
              >
                <FormattedMessage defaultMessage="¿Has olvidado tu contraseña?" />
              </Copy>
            </Copy>
          </Box>
          {socialButtons}
        </Flex>
        <Box>{renderReCaptcha()}</Box>
        <TwoFaModal
          logo={logo}
          request={request}
          start2faAuth={start2faAuth}
          params={params}
          onSuccess={onLoginSuccess}
          onConnectionError={onReceiveError}
          userEmail={(params && params.email) || ' '}
          isCaptchaLoading={disabled}
          refreshReCaptcha={refreshReCaptcha}
        />
      </Box>
    </LocalForm>
  )
}

LoginForm.propTypes = {
  socialButtons: PropTypes.node,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func,
  requestPasswordPath: PropTypes.string.isRequired,
  logo: PropTypes.node,
  renderReCaptcha: PropTypes.func,
  refreshReCaptcha: PropTypes.func,
  request: PropTypes.func.isRequired,
  start2faAuth: PropTypes.number.isRequired,
  params: PropTypes.object,
  onLoginSuccess: PropTypes.func,
  onReceiveError: PropTypes.func,
}

LoginForm.defaultProps = {
  // eslint-disable-next-line react/display-name
  renderReCaptcha: () => <div />,
  refreshReCaptcha: () => {},
  onSubmit: () => {},
  requestPasswordPath: '',
  errors: {},
  disabled: true,
  start2faAuth: 0,
  loading: false,
  logo: null,
  socialButtons: null,
}

export default LoginForm
